/* Raw Water Co. v2 — PDP buy-box interactivity.
   - One-time / Subscribe toggle (shows frequency, enables selling_plan)
   - Live CRV price breakdown + total + qty note as quantity changes
   - Gallery thumbnail switching + add-button label
   Cart add (box + CRV mirror) is handled by rwc-crv-sync.js on submit. */
(function () {
  function money(cents) {
    var n = cents / 100;
    return "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  function initPdp(section) {
    if (section.dataset.v2Init) return;
    section.dataset.v2Init = "1";

    var bottlesPerBox = parseInt(section.getAttribute("data-bottles-per-box"), 10) || 12;
    var crvPerBottle = parseFloat(section.getAttribute("data-crv-per-bottle")) || 0.10;
    var boxPrice = parseInt(section.getAttribute("data-box-price"), 10) || 0; // cents

    var form = section.querySelector(".v2-pdp__form");
    var qtyInput = section.querySelector("[data-v2-qty]");
    var plans = section.querySelectorAll(".v2-pdp__plan");
    var freq = section.querySelector(".v2-pdp__freq");
    var select = freq ? freq.querySelector("select") : null;
    var addBtn = section.querySelector("[data-v2-add]");
    var addBase = addBtn ? addBtn.textContent.trim() : "Add to cart";

    var elTotal = section.querySelector("[data-v2-total]");
    var elUnit = section.querySelector("[data-v2-unit]");
    var elWater = section.querySelector("[data-v2-water]");
    var elWaterLabel = section.querySelector("[data-v2-water-label]");
    var elCrv = section.querySelector("[data-v2-crv]");
    var elCrvLabel = section.querySelector("[data-v2-crv-label]");
    var elQtyNote = section.querySelector("[data-v2-qty-note]");
    var step = parseInt(qtyInput && qtyInput.getAttribute("step"), 10) || 5;

    function isSubscribe() {
      var sub = section.querySelector('.v2-pdp__plan[data-v2-plan="subscribe"]');
      return sub && sub.classList.contains("v2-pdp__plan--active");
    }

    function recalc() {
      var boxes = parseInt(qtyInput && qtyInput.value, 10) || 0;
      var bottles = boxes * bottlesPerBox;
      var water = boxPrice * boxes;                       // cents
      var crv = Math.round(crvPerBottle * 100) * bottles; // cents
      var total = water + crv;

      if (elWater) elWater.textContent = money(water);
      if (elCrv) elCrv.textContent = money(crv);
      if (elTotal) elTotal.textContent = money(total);
      if (elUnit) elUnit.textContent = "/ " + boxes + " case" + (boxes === 1 ? "" : "s");
      if (elWaterLabel) elWaterLabel.textContent = boxes + " case" + (boxes === 1 ? "" : "s") + " × " + money(boxPrice);
      if (elCrvLabel) elCrvLabel.textContent = "CRV deposit · " + bottles + " bottles × " + money(Math.round(crvPerBottle * 100));
      if (elQtyNote) elQtyNote.textContent = bottles + " bottles total · adjusts in steps of " + step + " cases";
      if (addBtn) addBtn.textContent = (isSubscribe() ? "Subscribe — " : "Add to cart — ") + money(total);
    }

    function selectPlan(which) {
      plans.forEach(function (p) {
        var on = p.getAttribute("data-v2-plan") === which;
        p.classList.toggle("v2-pdp__plan--active", on);
        var radio = p.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });
      var sub = which === "subscribe";
      if (freq) freq.hidden = !sub;
      if (select) select.disabled = !sub;
      recalc();
    }

    plans.forEach(function (p) {
      p.addEventListener("click", function (e) {
        e.preventDefault();
        selectPlan(p.getAttribute("data-v2-plan"));
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener("input", recalc);
      qtyInput.addEventListener("change", recalc);
      // rwc-qty-step.js updates the value on +/- clicks; recalc shortly after.
      section.querySelectorAll(".v2-pdp__qty-btn").forEach(function (btn) {
        btn.addEventListener("click", function () { setTimeout(recalc, 0); });
      });
    }

    // Gallery thumbs
    section.querySelectorAll(".v2-pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var target = document.getElementById(thumb.getAttribute("data-target"));
        if (target) target.src = thumb.getAttribute("data-full");
        section.querySelectorAll(".v2-pdp__thumb").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    recalc();
  }

  function initAll() { document.querySelectorAll(".v2-pdp").forEach(initPdp); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
